import React, {Component} from 'react';
import {connect} from 'react-redux';
import Lineup from './lineup';

class LineupsComparison extends Component {
    getLateswapLineupView() {
        const {lateswapSimplexLineups, lateswapLineupViews, rawLineups, lineupId} = this.props;

        const rawLineup = rawLineups.getLineup(lineupId);

        if (!rawLineup) {
            return null;
        }

        const lateswapSimplexLineup = lateswapSimplexLineups.getOneByEntryId(rawLineup.getEntryId());

        if (!lateswapSimplexLineup) {
            return null;
        }

        return lateswapLineupViews.getOneByLineupId(lateswapSimplexLineup.getId());
    }
    getReOptimizedLineupView() {
        const {lineups, lineupId} = this.props;

        return lineups.getLineup(lineupId);
    }
    render() {
        const lateswapLineupView = this.getLateswapLineupView();
        const reOptimizedLineup = this.getReOptimizedLineupView();

        return (
            <div className={'results-wrap'}>
                <div className={'results-content'}>
                    <Lineup lineupPlayers={lateswapLineupView.players} lineup={lateswapLineupView} />
                </div>
                <div className={'results-content'}>
                    <Lineup lineupPlayers={reOptimizedLineup.players} lineup={reOptimizedLineup} />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups, rawLineups},
        lateSwap: {simplexLineups, lineupViews},
    } = state;

    return {
        lineups,
        rawLineups,
        lateswapSimplexLineups: simplexLineups,
        lateswapLineupViews: lineupViews,
    };
}

export default connect(mapStatesToProps)(LineupsComparison);
